import { hasMaxLength, isFileUploaded } from '../../hooks/formValidator/validators';
const useInstitutionVerificationFormValidationSchema = () => {
    const inputsValidationSchema = {
        message: [hasMaxLength(250)],
    };
    const selectsValidationSchema = {
        file: [isFileUploaded],
    };
    return { inputsValidationSchema, selectsValidationSchema };
};
export default useInstitutionVerificationFormValidationSchema;
